import React from "react";
/**
 * Component wrapping the footer.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Footer(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=Footer.js.map